<!-- navbar.component.html -->
<div class="sm:ml-64">
  <nav class="border-b bg-blue-50/30">
    <div class="flex flex-wrap items-center justify-between max-w-screen-xl p-4 mx-auto">
      <!-- Logo -->
      <a routerLink="/inspection/collection" class="flex items-center space-x-3 rtl:space-x-reverse">
        <span class="self-center text-2xl font-semibold text-gray-800">CERTIPORT</span>
      </a>

      <div class="flex items-center space-x-4">
        <!-- Profil utilisateur -->
        <div *ngIf="user" class="flex items-center space-x-3">
          <div class="flex-shrink-0">
            <div
              class="flex items-center justify-center w-10 h-10 text-lg font-bold text-white transition-colors duration-200 bg-blue-600 rounded-full hover:bg-blue-700"
              [style.background]="user.profileColor">
              {{ user.lastName.charAt(0).toUpperCase() }}{{ user.firstName.charAt(0).toUpperCase() }}
            </div>
          </div>
          <div class="hidden sm:block">
            <p class="text-sm font-medium text-gray-800" *ngIf="user.role !== 'SUPER_ADMIN'">
              {{ user.lastName.charAt(0).toUpperCase() }}. {{ user.firstName }}
            </p>
            <p class="text-sm font-medium text-gray-800" *ngIf="user.role === 'SUPER_ADMIN'">
              Espace Administrateur
            </p>
          </div>
        </div>

        <!-- Bouton menu mobile -->
        <button data-drawer-target="cta-button-sidebar" data-drawer-toggle="cta-button-sidebar"
          aria-controls="cta-button-sidebar" type="button"
          class="inline-flex items-center p-2 text-sm text-blue-600 transition-colors duration-200 rounded-lg sm:hidden hover:bg-blue-100/50 focus:outline-none focus:ring-2 focus:ring-blue-200">
          <span class="sr-only">Open sidebar</span>
          <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
            <path clip-rule="evenodd" fill-rule="evenodd"
              d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
            </path>
          </svg>
        </button>
      </div>
    </div>
  </nav>

  <!-- Bannière d'alerte licence (juste en dessous de la navbar) -->
  <div *ngIf="showLicenceBanner && !isSuperAdmin"
    class="relative border-l-4 border-yellow-400 bg-gradient-to-r from-yellow-50 to-orange-50">
    <div class="max-w-screen-xl px-4 py-3 mx-auto">
      <div class="flex flex-wrap items-center justify-between">
        <div class="flex items-center flex-1">
          <div class="flex-shrink-0">
            <svg class="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-yellow-800">
              ⚠️ Votre licence est <span class="font-bold">inactive ou expirée</span>.
              Veuillez la renouveler pour continuer à utiliser l'application.
            </p>
          </div>
        </div>
        <div class="mt-2 shrink-0 sm:mt-0">
          <a routerLink="inactive/demand-licence"
            class="inline-flex items-center px-3 py-1 text-sm font-medium text-white bg-yellow-500 rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
              </path>
            </svg>
            Renouveler ma licence
          </a>
        </div>
      </div>
    </div>
  </div>
</div>